export interface UseActions {
  assignStudents: (data: any) => Promise<void>;
}
type ActionType = 'create' | 'update' | 'delete';

export default function useActions(props: {
  onSuccess: (action: ActionType) => void;
  onError: (action: ActionType, message?: string) => void;
}) {
  const { onSuccess } = props;

  return {
    assignStudents: (data: any) => {
      return onSuccess('create');
    },
  };
}
